import React from 'react';

import { ContactsListPage } from '../../shared/contacts/ContactsListPage';

const STAFF_CONTACTS_LIST_QUERY_KEY = 'staffContactsList';

export const StaffContactsList: React.FC = () => {
  return (
    <ContactsListPage
      title="Contacts"
      queryKeyBase={STAFF_CONTACTS_LIST_QUERY_KEY}
      displayTypePrefKey="StaffContacts"
      showOrganization={true}
      showOrganizationFilter={true}
      enableBulkActions={true}
    />
  );
};
